// a library to wrap and simplify api calls
import Api from './PhiApi'

const checkIfGood = (response) => {
    return Boolean(response.ok && response.data && response.data.results && response.data.results.length > 0)
}

export default class PhiLog {

    constructor(options) {
        this.phiRef = options

        this.sendMessage = function* (that, config){
            let token = that.phiRef.getSession()
            if (Boolean(token.jwt)) {
                let response = yield Api.sendMessage(config)
                if (checkIfGood(response)) {
                    return response.data.results[0]
                } else {
                    return {error: response.problem}
                }                    
            }
            return null
        }

        this.fetchMessages = function* (that, config){
            let token = that.phiRef.getSession()
            if (Boolean(token.jwt)) {
                let response = yield Api.fetchMessages(config)
                if (checkIfGood(response)) {
                    return response.data.results
                } else {
                    return {error: true}
                }                    
            }
            return null
        }

        this.fetchMessagesFrom = function* (that, config){
            let token = that.phiRef.getSession()
            if (Boolean(token.jwt)) {
                let response = yield Api.fetchMessagesFrom(config)
                if (checkIfGood(response)) {
                    return response.data.results
                } else {
                    return {error: true}
                }                    
            }
            return null
        }

        this.fetchMessageReceivers = function* (that, config){
            let token = that.phiRef.getSession()
            if (Boolean(token.jwt)) {
                let response = yield Api.fetchMessageReceivers(config)
                if (checkIfGood(response)) {
                    return response.data.results[0]
                } else {
                    return {error: true}
                }                 
            }
            return null
        }

        this.fetchMessageUnreadCount = function* (that, config){
            let token = that.phiRef.getSession()
            if (Boolean(token.jwt)) {
                let response = yield Api.fetchMessageUnreadCount(config)
                if (checkIfGood(response)) {
                    return response.data.results[0]
                } else {
                    return {error: true}
                }                 
            }
            return null
        }

    }
}


// WEBPACK FOOTER //
// ./src/Phi/PhiMessage.js